import React from "react";
import { Helmet } from "react-helmet";

const BlogItemListSchema = ({ posts, siteUrl }) => {
  if (!posts?.length) return null;

  const baseUrl = siteUrl.replace(/\/$/, "");
  const itemListElement = posts.map((post, index) => ({
    "@type": "ListItem",
    position: index + 1,
    url: `${baseUrl}/blog/${post.slug}/`,
  }));

  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default BlogItemListSchema;
